export const industry_selector_list = [
  "Industrial - General",
  "FMCG",
  "Plastic & Petro-Chemicals",
  "Industrials - Electricals - Cables",
  "Reefer - Frozen",
  "Cars & vehicles",
  "Coatings & paintings",
  "Electronics & Home appliances",
  "Food, beverages, and agricultural",
  "Furniture & Wood",
  "Garments & textiles",
  "Glass & ceramics",
  "Leathers",
  "Medical",
  "Metal & steel",
  "Paper & cartons",
  "Petrochemicals & fertilizers",
  "Shipping",
  "Wires & devices",
  "Trading",
  "Other"
];
